import map from "lodash/fp/map";
import startCase from "lodash/fp/startCase";
import constants from "../../core/constants";
import { toObject } from "../../core/utils";

class ManualInvoiceItemPageTransform {
  constructor() {
    "ngInject";
  }

  justify(item) {
    const formatCities = (city) => {
      city.maximum_limit /= constants.currencyBy;

      return city;
    };

    item.category = startCase(item.category);
    item.tags = map(startCase)(item.tags).join(", ");
    item.cities = map(formatCities)(item.cities);

    return toObject(item);
  }
}

export default ManualInvoiceItemPageTransform;



// WEBPACK FOOTER //
// ./src/pages/manualInvoiceItem/manualInvoiceItem.transforms.js